import { useEffect } from "react";

interface Options {
  disabled?: boolean;
}

const useSetInterval = (callback: () => void, delayMs: number, options?: Options) => {
  useEffect(() => {
    const timer = options?.disabled ? undefined : setInterval(callback, delayMs);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [callback, delayMs, options?.disabled]);
};

export default useSetInterval;
